export const stringUnwrap = (
  wrapperLeft: string,
  wrappedString: string,
  wrapperRight?: string
): string => {
  let result = wrappedString;

  if (result.startsWith(wrapperLeft)) {
    result = result.substring(wrapperLeft.length);
  }

  const right = wrapperRight || wrapperLeft;

  if (result.endsWith(right)) {
    result = result.substring(0, result.length - right.length);
  }

  return result;
};
